<template>
  <div class="wrapper">
    <div class="card-container">
      <div class="block">
        <div class="card-content-wrapper">
          <div class="card-content">
            <div class="subicon-image-container">
              <img
                class="subicon-image"
                :src="shareInfo.congratulation.subIcon"
              />
            </div>
            <div class="overlay-image-container">
              <img class="overlay-image" :src="shareInfo.congratulation.icon" />
            </div>
            <!-- <div class="overlay-main-text">{{shareInfo.congratulation.title}}</div>
            <div class="overlay-sub-text">{{shareInfo.congratulation.subTitle}}</div> -->
          </div>
          <div style="display: flex; flex-direction: column; padding: 0 20px">
            <!-- <div class="label-answer-time">
              <span class="label-answer-time-text">{{formatDate(shareInfo.answerTime)}}</span>
            </div> -->
            <div class="overlay-remind-container">
              <div class="overlay-remind-img-container">
                <img
                  class="dialog-box-icon"
                  :src="require('@/assets/imgs/dailyShare/cat.png')"
                />
              </div>
              <div class="dialog-box-container">
                <div class="dialog-box-text">{{ shareInfo.conclusion }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!this.$route.query.bySelf"
      style="
        width: 100vw;
        background-color: white;
        align-items: center;
        display: flex;
        text-align: center;
        justify-content:center
        padding : 0 auto;
      "
    >
      <div style="width: 90vw; padding: 20px 8vw; display: flex;">
        <div style="width: 100%">
          <img
            style="width: 100%; height: auto"
            :src="require('@/assets/imgs/dailyShare/share_bottom.png')"
          />
        </div>

        <img class="image-qrcode" :src="shareInfo.qrCode" />
      </div>
    </div>

    <div v-else style="height: 15vw; padding: 20px; display: flex"></div>
    <van-popup
      v-model="showPopup"
      position="top"
      custom-style="height: 20%;background-color:#00000000"
      @close="onClose"
    >
      <div style="color: white; display: flex; flex-direction: column">
        <div style="margin-right: 30px; margin-top: 20px; text-align: right">
          <img
            style="width: 50px"
            src="@/assets/imgs/vote/top_right_guide.jpg"
          />
        </div>
        <div style="text-align: center; font-size: 18px; font-weight: bold">
          点击上方“···”分享到微信朋友圈，
          <br />分享成功可得1天会员权限。
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import QRCode from "qrcode";
import {
  getDailyShareContent,
  postDailyReportShareResult,
  reportRecordVisitInfo,
} from "@/api/share";
import wx from "weixin-js-sdk";
import { ShareSource } from "@/contants";
import moment from "moment";

export default {
  name: "DailyReport",
  props: {},

  data() {
    return {
      posterImageUrl: "",
      // userPhoto: '',
      showLoading: false,
      showPopup: false,
      shareInfo: {
        conclusion: "",
        congratulation: {
          icon: "",
          level: 1,
          subTitle: "",
          title: "",
        },
        headImageUrl: "",
        answerTime: 1589621909000,
        qrCode: 1222,
        shareInfoVO: {
          desc: "string",
          imgUrl: "string",
          title: "string",
        },
      },
    };
  },

  activated() {
    //重置进入页面的状态
    this.posterImageUrl = "";
    this.showLoading = false;
    // this.shareGuide = false;
    this.getShareInfo();
  },

  computed: {
    // photo() {
    //   let phone64 = 'data:image/jpeg;base64,' + this.$store.state.userInfo.headImgUrlBase64;
    //   const img = require('@/assets/imgs/readLog.jpeg')
    //   return this.$store.state.userInfo.headImgUrlBase64 ? phone64 : img
    // },
    // nickName() {
    //   return this.$store.state.userInfo.nickname
    // }
  },

  components: {},

  mounted() {
    if (!this.$route.query.bySelf) {
      reportRecordVisitInfo({ shareRecordId: this.$route.query.shareRecordId });
    }
  },
  methods: {
    formatDate(timestamp) {
      return moment(timestamp).format("YYYY/MM/DD");
    },
    //获取海报
    onClose() {
      this.showPopup = false;
    },
    getShareInfo() {
      if (this.$route.query.shareRecordId) {
        // this.$toast("获取分享信息失败");
        getDailyShareContent({
          shareRecordId: this.$route.query.shareRecordId,
          shareReadRecordId: this.$route.query.shareReadRecordId,
        })
          .then((result) => {
            if (!this.$route.query.bySelf) {
              this.reportShareResult();
            }
            this.shareInfo = result.data;
            wx.ready(() => {
              //   this.showPopup = true;
              this.shareInfo = result.data;
              wx.showMenuItems({
                menuList: [
                  "menuItem:share:appMessage",
                  "menuItem:share:timeline",
                  // 'menuItem:favorite',
                  // 'menuItem:share:qq',
                  // 'menuItem:share:weiboApp',
                  // 'menuItem:share:facebook',
                  // 'menuItem:share:QZone',
                  // 'menuItem:copyUrl',
                  // 'menuItem:openWithQQBrowser',
                  // 'menuItem:openWithSafari',
                  // 'menuItem:share:email'
                ],
              });
              // http://oss-leveledreading.oss-cn-beijing.aliyuncs.com/rewardpointgoods/1.png
              wx.updateAppMessageShareData({
                title: result.data.shareInfoVO.title, // 分享标题
                desc: result.data.shareInfoVO.desc, // 分享描述
                link: result.data.shareInfoVO.link, // 分享链接
                imgUrl: result.data.shareInfoVO.imgUrl, // 分享图标
                success: () => {
                  // this.reportShareResult();
                },
              });
              wx.updateTimelineShareData({
                title: result.data.shareInfoVO.title, // 分享标题
                // desc: result.data.shareInfoVO.desc, // 分享描述
                link: result.data.shareInfoVO.link, // 分享链接
                imgUrl: result.data.shareInfoVO.imgUrl, // 分享图标
                success: () => {},
              });
            });
          })
          .catch(() => {
            this.$toast("获取分享信息失败");
          });

        return;
      }
    },
    reportShareResult() {
      // this.$toast("分享成功");
      postDailyReportShareResult({
        shareRecordId: this.$route.query.shareRecordId,
      })
        .then((result) => {
          console.log("分享成功");
        })
        .catch((error) => {
          console.log("上报分享结果失败，", error);
        });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../stylesheet/common.styl';

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 0 15px;
  background-image: url('../../assets/imgs/dailyShare/background.png');
  background-size: 100% 100%;
  background-repeat: 'repeat';
  font-family: serif;
}

.block {
  // border: 1px solid #cccccc;
  // border-radius: 16px;
  // background-color: #fff;
  height: 100%;
  // background-image: url('../../assets/imgs/dailyShare/card_bg.png');
  background-repeat: 'repeat';
}

.card-content-wrapper {
  display: flex;
  flex-direction: column;
  // padding: 0 20px;
  height: 100%;
  flex: 1;
  justify-content: space-between;
}

.subicon-image {
  // text-align: center;
  margin-top: 50px;
  height: 80px;
}

.overlay-image-container {
  text-align: center;
  margin-top: 50px;
  height: 50vw;
}

.overlay-image {
  text-align: center;
  height: 50vw;
}

.overlay-title {
  display: flex;
  flex-direction: row;
  font-size: 20px;
  font-weight: bold;
  justify-content: space-between;
}

.overlay-main-text {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 8px;
}

.overlay-sub-text {
  font-size: 14px;
  text-align: center;
  margin-top: 2px;
  color: #333333;
}

.overlay-item {
  display: flex;
  margin: 20px 0;
  flex-direction: row;
  font-size: 16px;
}

.overlay-item-text-label {
  font-weight: bold;
  color: #454550;
}

.overlay-item-text-content {
  flex: 1;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-word;
  color: #454550;
}

.overlay-remind-container {
  display: flex;
  height: 72px;
  flex-direction: row;
  align-items: center;
  margin: 10px 0 20px 0;
}

.overlay-remind-img-container {
  display: flex;
  height: 72px;
  flex-direction: row;
  align-items: center;
}

.dialog-box-icon {
  width: 54px;
  height: 54px;
  margin-right: 10px;
}

.dialog-box-container {
  height: 72px;
  background-size: 100% 100%;
  background-image: url('../../assets/imgs/dailyShare/dialog_box_bg.png');
  align-items: center;
}

.dialog-box-text {
  margin: 0 20px 0 20px;
  font-size: 14px;
  color: white;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.card-container {
  flex: 1;
  width: 100%;
}

.card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 20px;
  justify-content: flex-start;
}

.image-qrcode {
  // margin-left: 10px;
  position: absolute;
  // margin-top: (-100vw/3) + 20px;
  // display: block;
  // width: 30vw
  // top:20px;
  margin-top: 2.2vw;
  margin-left: 1.8vw;
  width: 20vw;
  height: 20vw;
}

.label-answer-time {
  flex-direction: row;
  text-align: right;
}

.label-answer-time-text {
  color: #999999;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// app/pages/share/DailyReport.vue